/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { BadRequestResponse } from '../model/badRequestResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { InternalServerErrorResponse } from '../model/internalServerErrorResponse';
// @ts-ignore
import { PermissionDeniedResponse } from '../model/permissionDeniedResponse';
// @ts-ignore
import { SemGetRedirectResponse } from '../model/semGetRedirectResponse';
// @ts-ignore
import { SemUsePatternRequest } from '../model/semUsePatternRequest';
// @ts-ignore
import { SemUsePatternResponse } from '../model/semUsePatternResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface GetSemRedirectRequestParams {
    /** Проверяемый путь адреса. */
    uRLPath: string;
    /** Доставка / Самовывоз, обязательный хедер */
    xDeliveryMode: 'delivery' | 'pickup' | 'shop';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Хост запроса. Используется для определения retailBrand и поддомена. */
    xQueryHost?: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand?: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface SemUsepatternRequestParams {
    /** Сессионный токен */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Доставка / Самовывоз, обязательный хедер */
    xDeliveryMode: 'delivery' | 'pickup' | 'shop';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Тело запроса */
    semUsePatternRequest: SemUsePatternRequest;
    /** Хост запроса. Используется для определения retailBrand и поддомена. */
    xQueryHost?: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand?: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}


@Injectable({
  providedIn: 'root'
})
export class SEMService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Редирект из sem.
     * Проверить путь - нужен ли редирект.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSemRedirect(requestParameters: GetSemRedirectRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SemGetRedirectResponse>;
    public getSemRedirect(requestParameters: GetSemRedirectRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SemGetRedirectResponse>>;
    public getSemRedirect(requestParameters: GetSemRedirectRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SemGetRedirectResponse>>;
    public getSemRedirect(requestParameters: GetSemRedirectRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const uRLPath = requestParameters.uRLPath;
        if (uRLPath === null || uRLPath === undefined) {
            throw new Error('Required parameter uRLPath was null or undefined when calling getSemRedirect.');
        }
        const xDeliveryMode = requestParameters.xDeliveryMode;
        if (xDeliveryMode === null || xDeliveryMode === undefined) {
            throw new Error('Required parameter xDeliveryMode was null or undefined when calling getSemRedirect.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getSemRedirect.');
        }
        const xQueryHost = requestParameters.xQueryHost;
        const xRetailBrand = requestParameters.xRetailBrand;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (uRLPath !== undefined && uRLPath !== null) {
            localVarHeaders = localVarHeaders.set('URL-Path', String(uRLPath));
        }
        if (xQueryHost !== undefined && xQueryHost !== null) {
            localVarHeaders = localVarHeaders.set('X-Query-Host', String(xQueryHost));
        }
        if (xDeliveryMode !== undefined && xDeliveryMode !== null) {
            localVarHeaders = localVarHeaders.set('X-Delivery-Mode', String(xDeliveryMode));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'MI',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sem/redirect`;
        return this.httpClient.request<SemGetRedirectResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Шаблоны СЕО.
     * Получить мета теги для страницы.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public semUsepattern(requestParameters: SemUsepatternRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SemUsePatternResponse>;
    public semUsepattern(requestParameters: SemUsepatternRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SemUsePatternResponse>>;
    public semUsepattern(requestParameters: SemUsepatternRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SemUsePatternResponse>>;
    public semUsepattern(requestParameters: SemUsepatternRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling semUsepattern.');
        }
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling semUsepattern.');
        }
        const xDeliveryMode = requestParameters.xDeliveryMode;
        if (xDeliveryMode === null || xDeliveryMode === undefined) {
            throw new Error('Required parameter xDeliveryMode was null or undefined when calling semUsepattern.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling semUsepattern.');
        }
        const semUsePatternRequest = requestParameters.semUsePatternRequest;
        if (semUsePatternRequest === null || semUsePatternRequest === undefined) {
            throw new Error('Required parameter semUsePatternRequest was null or undefined when calling semUsepattern.');
        }
        const xQueryHost = requestParameters.xQueryHost;
        const xRetailBrand = requestParameters.xRetailBrand;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xQueryHost !== undefined && xQueryHost !== null) {
            localVarHeaders = localVarHeaders.set('X-Query-Host', String(xQueryHost));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xDeliveryMode !== undefined && xDeliveryMode !== null) {
            localVarHeaders = localVarHeaders.set('X-Delivery-Mode', String(xDeliveryMode));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SkipSessionTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('SkipSessionTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SkipSessionTokenAuth', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'MI',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sem/usepattern`;
        return this.httpClient.request<SemUsePatternResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: semUsePatternRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
